import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/rental-contracts')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.rentalContracts',
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry/rental-contracts') {
      throw redirect({
        to: '/dashboard/rental-contracts',
      });
    }
  },
});
